// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_proyectos.proto (package sextante.plataforma.proyectos.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_proyectos.proto.
 */
export const file_plataforma_proyectos: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectosVacioRequest
 */
export type ProyectosVacioRequest = Message<"sextante.plataforma.proyectos.v1.ProyectosVacioRequest"> & {
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectosVacioRequest.
 * Use `create(ProyectosVacioRequestSchema)` to create a new message.
 */
export const ProyectosVacioRequestSchema: GenMessage<ProyectosVacioRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 0);

/**
 * Sin datos: que el rpc no falle ya indica que se hizo.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectosAccionResponse
 */
export type ProyectosAccionResponse = Message<"sextante.plataforma.proyectos.v1.ProyectosAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectosAccionResponse.
 * Use `create(ProyectosAccionResponseSchema)` to create a new message.
 */
export const ProyectosAccionResponseSchema: GenMessage<ProyectosAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 1);

/**
 * KPIs del dashboard.
 *
 * @generated from message sextante.plataforma.proyectos.v1.DashboardProyectosStatsResponse
 */
export type DashboardProyectosStatsResponse = Message<"sextante.plataforma.proyectos.v1.DashboardProyectosStatsResponse"> & {
  /**
   * @generated from field: int32 proyectos_activos = 1;
   */
  proyectosActivos: number;

  /**
   * @generated from field: int32 nuevos_este_mes = 2;
   */
  nuevosEsteMes: number;

  /**
   * @generated from field: double total_ha = 3;
   */
  totalHa: number;

  /**
   * @generated from field: int32 tecnicos_activos = 4;
   */
  tecnicosActivos: number;

  /**
   * Ausentes si no hay snapshot activo.
   *
   * @generated from field: optional int32 snapshot_anio = 5;
   */
  snapshotAnio?: number | undefined;

  /**
   * @generated from field: optional double snapshot_ipc = 6;
   */
  snapshotIpc?: number | undefined;

  /**
   * @generated from field: int64 capex_presupuestado = 7;
   */
  capexPresupuestado: bigint;

  /**
   * @generated from field: int64 capex_ejecutado = 8;
   */
  capexEjecutado: bigint;

  /**
   * @generated from field: int64 opex_presupuestado = 9;
   */
  opexPresupuestado: bigint;

  /**
   * @generated from field: int64 opex_ejecutado = 10;
   */
  opexEjecutado: bigint;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.HaPorCultivoItem ha_por_cultivo = 11;
   */
  haPorCultivo: HaPorCultivoItem[];

  /**
   * Top 5 items con mayor desviacion agregada entre proyectos activos.
   *
   * @generated from field: repeated sextante.plataforma.proyectos.v1.MayorDesviacionItem mayor_desviacion = 12;
   */
  mayorDesviacion: MayorDesviacionItem[];

  /**
   * @generated from field: int32 total_macro_proyectos = 13;
   */
  totalMacroProyectos: number;

  /**
   * @generated from field: int32 macro_proyectos_activos = 14;
   */
  macroProyectosActivos: number;

  /**
   * @generated from field: int32 total_nucleos = 15;
   */
  totalNucleos: number;

  /**
   * Clientes distintos con al menos un proyecto no eliminado.
   *
   * @generated from field: int32 total_beneficiarios = 16;
   */
  totalBeneficiarios: number;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.ProyectoPorEstadoItem proyectos_por_estado = 17;
   */
  proyectosPorEstado: ProyectoPorEstadoItem[];

  /**
   * Proyectos en revision.
   *
   * @generated from field: int32 proyectos_pendientes_aprobacion = 18;
   */
  proyectosPendientesAprobacion: number;

  /**
   * Proyectos en revision hace mas de 5 dias, contados desde su ultimo cambio de estado.
   *
   * @generated from field: int32 proyectos_pendientes_mas_de_5_dias = 19;
   */
  proyectosPendientesMasDe5Dias: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.DashboardProyectosStatsResponse.
 * Use `create(DashboardProyectosStatsResponseSchema)` to create a new message.
 */
export const DashboardProyectosStatsResponseSchema: GenMessage<DashboardProyectosStatsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 2);

/**
 * Cantidad de proyectos no eliminados en un estado.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectoPorEstadoItem
 */
export type ProyectoPorEstadoItem = Message<"sextante.plataforma.proyectos.v1.ProyectoPorEstadoItem"> & {
  /**
   * @generated from field: string estado = 1;
   */
  estado: string;

  /**
   * @generated from field: int32 cantidad = 2;
   */
  cantidad: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectoPorEstadoItem.
 * Use `create(ProyectoPorEstadoItemSchema)` to create a new message.
 */
export const ProyectoPorEstadoItemSchema: GenMessage<ProyectoPorEstadoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 3);

/**
 * Hectareas de proyectos activos de un cultivo.
 *
 * @generated from message sextante.plataforma.proyectos.v1.HaPorCultivoItem
 */
export type HaPorCultivoItem = Message<"sextante.plataforma.proyectos.v1.HaPorCultivoItem"> & {
  /**
   * @generated from field: string cultivo_nombre = 1;
   */
  cultivoNombre: string;

  /**
   * @generated from field: double total_ha = 2;
   */
  totalHa: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.HaPorCultivoItem.
 * Use `create(HaPorCultivoItemSchema)` to create a new message.
 */
export const HaPorCultivoItemSchema: GenMessage<HaPorCultivoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 4);

/**
 * Item del catalogo con mas desviacion entre lo presupuestado y lo gastado.
 *
 * @generated from message sextante.plataforma.proyectos.v1.MayorDesviacionItem
 */
export type MayorDesviacionItem = Message<"sextante.plataforma.proyectos.v1.MayorDesviacionItem"> & {
  /**
   * @generated from field: string item_nombre = 1;
   */
  itemNombre: string;

  /**
   * @generated from field: string cultivo_nombre = 2;
   */
  cultivoNombre: string;

  /**
   * @generated from field: int32 proyectos_afectados = 3;
   */
  proyectosAfectados: number;

  /**
   * Decimal: 0.22 = +22%.
   *
   * @generated from field: double desviacion = 4;
   */
  desviacion: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.MayorDesviacionItem.
 * Use `create(MayorDesviacionItemSchema)` to create a new message.
 */
export const MayorDesviacionItemSchema: GenMessage<MayorDesviacionItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 5);

/**
 * Proyectos.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListProyectosResponse
 */
export type ListProyectosResponse = Message<"sextante.plataforma.proyectos.v1.ListProyectosResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.ProyectoPlataformaItem items = 1;
   */
  items: ProyectoPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListProyectosResponse.
 * Use `create(ListProyectosResponseSchema)` to create a new message.
 */
export const ListProyectosResponseSchema: GenMessage<ListProyectosResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 6);

/**
 * Proyecto sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectoIdRequest
 */
export type ProyectoIdRequest = Message<"sextante.plataforma.proyectos.v1.ProyectoIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectoIdRequest.
 * Use `create(ProyectoIdRequestSchema)` to create a new message.
 */
export const ProyectoIdRequestSchema: GenMessage<ProyectoIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 7);

/**
 * Proyecto de cultivo con su presupuesto resumido.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectoPlataformaItem
 */
export type ProyectoPlataformaItem = Message<"sextante.plataforma.proyectos.v1.ProyectoPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * borrador | activo | cerrado
   *
   * @generated from field: string estado = 3;
   */
  estado: string;

  /**
   * @generated from field: string cliente_id = 4;
   */
  clienteId: string;

  /**
   * @generated from field: string cliente_nombre = 5;
   */
  clienteNombre: string;

  /**
   * @generated from field: string cultivo_id = 6;
   */
  cultivoId: string;

  /**
   * @generated from field: string cultivo_nombre = 7;
   */
  cultivoNombre: string;

  /**
   * Anio del snapshot economico congelado al crear el proyecto.
   *
   * @generated from field: int32 snapshot_anio = 8;
   */
  snapshotAnio: number;

  /**
   * @generated from field: double snapshot_ipc = 9;
   */
  snapshotIpc: number;

  /**
   * Valor del jornal diario del snapshot, en pesos.
   *
   * @generated from field: int64 snapshot_factor_jornal = 10;
   */
  snapshotFactorJornal: bigint;

  /**
   * @generated from field: string tecnico_id = 11;
   */
  tecnicoId: string;

  /**
   * @generated from field: string tecnico_nombre = 12;
   */
  tecnicoNombre: string;

  /**
   * @generated from field: optional string variedad = 13;
   */
  variedad?: string | undefined;

  /**
   * @generated from field: optional string municipio = 14;
   */
  municipio?: string | undefined;

  /**
   * @generated from field: double ha = 15;
   */
  ha: number;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_inicio = 16;
   */
  fechaInicio?: bigint | undefined;

  /**
   * @generated from field: optional string nota = 17;
   */
  nota?: string | undefined;

  /**
   * @generated from field: int32 total_items = 18;
   */
  totalItems: number;

  /**
   * @generated from field: int32 items_activos = 19;
   */
  itemsActivos: number;

  /**
   * Suma bruta de items activos con precio (sin IPC).
   *
   * @generated from field: int64 capex = 20;
   */
  capex: bigint;

  /**
   * @generated from field: int64 opex_anual = 21;
   */
  opexAnual: bigint;

  /**
   * Total de gastos reales.
   *
   * @generated from field: int64 ejecutado = 22;
   */
  ejecutado: bigint;

  /**
   * Unix ms
   *
   * @generated from field: int64 created_at = 23;
   */
  createdAt: bigint;

  /**
   * Macro-proyecto al que pertenece; ausente si es un proyecto suelto.
   *
   * @generated from field: optional string macro_proyecto_id = 24;
   */
  macroProyectoId?: string | undefined;

  /**
   * @generated from field: optional string macro_proyecto_nombre = 25;
   */
  macroProyectoNombre?: string | undefined;

  /**
   * Nucleo al que pertenece; ausente si no tiene.
   *
   * @generated from field: optional string nucleo_id = 26;
   */
  nucleoId?: string | undefined;

  /**
   * @generated from field: optional string nucleo_nombre = 27;
   */
  nucleoNombre?: string | undefined;

  /**
   * @generated from field: optional int32 duracion_meses = 28;
   */
  duracionMeses?: number | undefined;

  /**
   * Credito de referencia: solo informativo, la web avisa si el presupuesto lo supera.
   *
   * @generated from field: optional string entidad_financiera_referencia = 29;
   */
  entidadFinancieraReferencia?: string | undefined;

  /**
   * @generated from field: optional int64 limite_financiero_referencial = 30;
   */
  limiteFinancieroReferencial?: bigint | undefined;

  /**
   * Finca del cliente sobre la que corre el proyecto (el wizard muestra su nombre).
   *
   * @generated from field: optional string finca_id = 31;
   */
  fincaId?: string | undefined;

  /**
   * Meses hasta cosecha del cultivo (tira de contexto del wizard).
   *
   * @generated from field: int32 cultivo_meses_a_cosecha = 32;
   */
  cultivoMesesACosecha: number;

  /**
   * Items activos sin precio unitario: no suman al presupuesto (KPI "items activos" del detalle).
   *
   * @generated from field: int32 items_sin_precio = 33;
   */
  itemsSinPrecio: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectoPlataformaItem.
 * Use `create(ProyectoPlataformaItemSchema)` to create a new message.
 */
export const ProyectoPlataformaItemSchema: GenMessage<ProyectoPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 8);

/**
 * Gasto real de un item del proyecto.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GastoProyectoItem
 */
export type GastoProyectoItem = Message<"sextante.plataforma.proyectos.v1.GastoProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Unix ms
   *
   * @generated from field: int64 fecha = 2;
   */
  fecha: bigint;

  /**
   * @generated from field: double cantidad_real = 3;
   */
  cantidadReal: number;

  /**
   * @generated from field: int64 precio_unitario_real = 4;
   */
  precioUnitarioReal: bigint;

  /**
   * Cantidad por precio unitario, calculado por el servidor.
   *
   * @generated from field: int64 total = 5;
   */
  total: bigint;

  /**
   * @generated from field: optional string proveedor = 6;
   */
  proveedor?: string | undefined;

  /**
   * @generated from field: optional string observaciones = 7;
   */
  observaciones?: string | undefined;

  /**
   * Referencia de Nitrofert (remision o factura); solo en gastos registrados por NitrofertApi.
   *
   * @generated from field: optional string referencia = 8;
   */
  referencia?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GastoProyectoItem.
 * Use `create(GastoProyectoItemSchema)` to create a new message.
 */
export const GastoProyectoItemSchema: GenMessage<GastoProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 9);

/**
 * Solicitud de cantidad de un item (solo Nitrofert), con lo que Nitrofert lleva entregado.
 *
 * @generated from message sextante.plataforma.proyectos.v1.SolicitudProyectoItem
 */
export type SolicitudProyectoItem = Message<"sextante.plataforma.proyectos.v1.SolicitudProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Unix ms
   *
   * @generated from field: int64 fecha = 2;
   */
  fecha: bigint;

  /**
   * Cantidad pedida, en la unidad del item (cant_unidad).
   *
   * @generated from field: double cantidad = 3;
   */
  cantidad: number;

  /**
   * Suma de las cantidades de los gastos con que Nitrofert la atendio. Puede superar lo pedido.
   *
   * @generated from field: double entregado = 4;
   */
  entregado: number;

  /**
   * pendiente (sin entregas), parcial o completa (lo entregado llega a lo pedido).
   *
   * @generated from field: string estado = 5;
   */
  estado: string;

  /**
   * @generated from field: optional string observaciones = 6;
   */
  observaciones?: string | undefined;

  /**
   * Nombre del usuario que la pidio.
   *
   * @generated from field: optional string solicitado_por = 7;
   */
  solicitadoPor?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.SolicitudProyectoItem.
 * Use `create(SolicitudProyectoItemSchema)` to create a new message.
 */
export const SolicitudProyectoItemSchema: GenMessage<SolicitudProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 10);

/**
 * Item del presupuesto del proyecto, con sus gastos.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectoItemDetalleItem
 */
export type ProyectoItemDetalleItem = Message<"sextante.plataforma.proyectos.v1.ProyectoItemDetalleItem"> & {
  /**
   * Id del item del proyecto.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Id del item del catalogo (lo usan los gastos).
   *
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * Seccion del catalogo, para agrupar.
   *
   * @generated from field: string sec = 3;
   */
  sec: string;

  /**
   * Subseccion del catalogo, para agrupar.
   *
   * @generated from field: string sub = 4;
   */
  sub: string;

  /**
   * CAPEX | OPEX
   *
   * @generated from field: string tipo = 5;
   */
  tipo: string;

  /**
   * @generated from field: string nombre = 6;
   */
  nombre: string;

  /**
   * @generated from field: string categoria = 7;
   */
  categoria: string;

  /**
   * @generated from field: string unidad = 8;
   */
  unidad: string;

  /**
   * @generated from field: string cant_unidad = 9;
   */
  cantUnidad: string;

  /**
   * Como cambia el precio con los anios: smmlv, ipc, fijo o volatil.
   *
   * @generated from field: string tipo_p = 10;
   */
  tipoP: string;

  /**
   * Cantidad por hectarea.
   *
   * @generated from field: double cantidad = 11;
   */
  cantidad: number;

  /**
   * Ausente = sin precio.
   *
   * @generated from field: optional int64 precio_unitario = 12;
   */
  precioUnitario?: bigint | undefined;

  /**
   * precio_unitario x cantidad x frecuencia x ha; ausente sin precio.
   *
   * @generated from field: optional int64 presupuestado = 13;
   */
  presupuestado?: bigint | undefined;

  /**
   * @generated from field: int64 ejecutado = 14;
   */
  ejecutado: bigint;

  /**
   * Decimal; ausente sin presupuesto.
   *
   * @generated from field: optional double desviacion = 15;
   */
  desviacion?: number | undefined;

  /**
   * 0-1; ausente sin presupuesto.
   *
   * @generated from field: optional double avance = 16;
   */
  avance?: number | undefined;

  /**
   * @generated from field: bool activo = 17;
   */
  activo: boolean;

  /**
   * Item marcado NITRO: se resalta en el catalogo y el presupuesto.
   *
   * @generated from field: bool nitro = 18;
   */
  nitro: boolean;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.GastoProyectoItem gastos = 19;
   */
  gastos: GastoProyectoItem[];

  /**
   * Repeticiones dentro de la fase, congeladas al agregar el item. 1 = sin repeticiones.
   *
   * @generated from field: double freq = 20;
   */
  freq: number;

  /**
   * Fase del item del catalogo; ausente en items viejos, sin fase.
   *
   * @generated from field: optional string fase_id = 21;
   */
  faseId?: string | undefined;

  /**
   * @generated from field: optional string fase_codigo = 22;
   */
  faseCodigo?: string | undefined;

  /**
   * Avance real de la labor que marca el tecnico: pendiente, en_ejecucion o completado. No sale del gasto.
   *
   * @generated from field: string avance_estado = 23;
   */
  avanceEstado: string;

  /**
   * Solicitudes de cantidad del item (solo Nitrofert), de la mas reciente a la mas antigua.
   *
   * @generated from field: repeated sextante.plataforma.proyectos.v1.SolicitudProyectoItem solicitudes = 24;
   */
  solicitudes: SolicitudProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectoItemDetalleItem.
 * Use `create(ProyectoItemDetalleItemSchema)` to create a new message.
 */
export const ProyectoItemDetalleItemSchema: GenMessage<ProyectoItemDetalleItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 11);

/**
 * KPIs del presupuesto del proyecto.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectoKpis
 */
export type ProyectoKpis = Message<"sextante.plataforma.proyectos.v1.ProyectoKpis"> & {
  /**
   * @generated from field: int64 presupuesto_total = 1;
   */
  presupuestoTotal: bigint;

  /**
   * @generated from field: int64 ejecutado_total = 2;
   */
  ejecutadoTotal: bigint;

  /**
   * @generated from field: int64 disponible = 3;
   */
  disponible: bigint;

  /**
   * Decimal: 0.22 = +22%.
   *
   * @generated from field: double desviacion_global = 4;
   */
  desviacionGlobal: number;

  /**
   * verde | amarillo | rojo
   *
   * @generated from field: string semaforo = 5;
   */
  semaforo: string;

  /**
   * @generated from field: int32 items_en_alerta = 6;
   */
  itemsEnAlerta: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectoKpis.
 * Use `create(ProyectoKpisSchema)` to create a new message.
 */
export const ProyectoKpisSchema: GenMessage<ProyectoKpis> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 12);

/**
 * Proyecto con KPIs e items.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ProyectoDetalleResponse
 */
export type ProyectoDetalleResponse = Message<"sextante.plataforma.proyectos.v1.ProyectoDetalleResponse"> & {
  /**
   * @generated from field: sextante.plataforma.proyectos.v1.ProyectoPlataformaItem proyecto = 1;
   */
  proyecto?: ProyectoPlataformaItem | undefined;

  /**
   * @generated from field: sextante.plataforma.proyectos.v1.ProyectoKpis kpis = 2;
   */
  kpis?: ProyectoKpis | undefined;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.ProyectoItemDetalleItem items = 3;
   */
  items: ProyectoItemDetalleItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ProyectoDetalleResponse.
 * Use `create(ProyectoDetalleResponseSchema)` to create a new message.
 */
export const ProyectoDetalleResponseSchema: GenMessage<ProyectoDetalleResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 13);

/**
 * Presupuesto del proyecto hasta la cosecha. Los items smmlv e ipc crecen cada anio con la tasa de IPC de su
 * categoria congelada en el proyecto; fijo y volatil quedan constantes. Redisenado el 2026-10-03 con la forma
 * que usa la web de Proyectos.
 *
 * @generated from message sextante.plataforma.proyectos.v1.PresupuestoProyectoResponse
 */
export type PresupuestoProyectoResponse = Message<"sextante.plataforma.proyectos.v1.PresupuestoProyectoResponse"> & {
  /**
   * @generated from field: double ha = 9;
   */
  ha: number;

  /**
   * @generated from field: int32 meses_a_cosecha = 10;
   */
  mesesACosecha: number;

  /**
   * IPC congelado en el proyecto, en decimal.
   *
   * @generated from field: double ipc = 11;
   */
  ipc: number;

  /**
   * @generated from field: int64 factor_jornal = 12;
   */
  factorJornal: bigint;

  /**
   * CAPEX bruto: se imputa todo al anio 1.
   *
   * @generated from field: int64 capex = 13;
   */
  capex: bigint;

  /**
   * OPEX proyectado hasta cosecha, con IPC compuesto. La serie de detalle_anual suma exactamente este valor.
   *
   * @generated from field: int64 opex_proyectado = 14;
   */
  opexProyectado: bigint;

  /**
   * @generated from field: int64 total = 15;
   */
  total: bigint;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.PresupuestoAnioItem detalle_anual = 16;
   */
  detalleAnual: PresupuestoAnioItem[];

  /**
   * Items activos del catalogo todavia sin precio.
   *
   * @generated from field: repeated string items_sin_precio = 17;
   */
  itemsSinPrecio: string[];

  /**
   * true si no hay items activos sin precio.
   *
   * @generated from field: bool presupuesto_completo = 18;
   */
  presupuestoCompleto: boolean;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.PresupuestoProyectoResponse.
 * Use `create(PresupuestoProyectoResponseSchema)` to create a new message.
 */
export const PresupuestoProyectoResponseSchema: GenMessage<PresupuestoProyectoResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 14);

/**
 * Un anio de la proyeccion del presupuesto.
 *
 * @generated from message sextante.plataforma.proyectos.v1.PresupuestoAnioItem
 */
export type PresupuestoAnioItem = Message<"sextante.plataforma.proyectos.v1.PresupuestoAnioItem"> & {
  /**
   * @generated from field: int32 anio = 1;
   */
  anio: number;

  /**
   * Porcion del anio que cubre el ciclo: 1 en los completos, menos de 1 en el ultimo si no cierra en 12 meses.
   *
   * @generated from field: double fraccion = 2;
   */
  fraccion: number;

  /**
   * @generated from field: int64 opex = 3;
   */
  opex: bigint;

  /**
   * Todo el CAPEX va al anio 1; 0 en el resto.
   *
   * @generated from field: int64 capex = 4;
   */
  capex: bigint;

  /**
   * @generated from field: int64 total = 5;
   */
  total: bigint;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.PresupuestoAnioItem.
 * Use `create(PresupuestoAnioItemSchema)` to create a new message.
 */
export const PresupuestoAnioItemSchema: GenMessage<PresupuestoAnioItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 15);

/**
 * Proyecto a crear o editar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarProyectoRequest
 */
export type GuardarProyectoRequest = Message<"sextante.plataforma.proyectos.v1.GuardarProyectoRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string cliente_id = 3;
   */
  clienteId: string;

  /**
   * @generated from field: string cultivo_id = 4;
   */
  cultivoId: string;

  /**
   * @generated from field: string tecnico_id = 5;
   */
  tecnicoId: string;

  /**
   * @generated from field: double ha = 6;
   */
  ha: number;

  /**
   * Finca del cliente donde se hace el proyecto. Obligatoria desde el 2026-10-24: si falta o no existe, el Server rechaza el guardado.
   *
   * @generated from field: optional string finca_id = 7;
   */
  fincaId?: string | undefined;

  /**
   * @generated from field: optional string variedad = 8;
   */
  variedad?: string | undefined;

  /**
   * @generated from field: optional string municipio = 9;
   */
  municipio?: string | undefined;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_inicio = 10;
   */
  fechaInicio?: bigint | undefined;

  /**
   * @generated from field: optional string nota = 11;
   */
  nota?: string | undefined;

  /**
   * @generated from field: optional string macro_proyecto_id = 12;
   */
  macroProyectoId?: string | undefined;

  /**
   * Ausente = hereda el nucleo del ultimo proyecto del mismo cliente, si tiene uno.
   *
   * @generated from field: optional string nucleo_id = 13;
   */
  nucleoId?: string | undefined;

  /**
   * @generated from field: optional int32 duracion_meses = 14;
   */
  duracionMeses?: number | undefined;

  /**
   * @generated from field: optional string entidad_financiera_referencia = 15;
   */
  entidadFinancieraReferencia?: string | undefined;

  /**
   * @generated from field: optional int64 limite_financiero_referencial = 16;
   */
  limiteFinancieroReferencial?: bigint | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarProyectoRequest.
 * Use `create(GuardarProyectoRequestSchema)` to create a new message.
 */
export const GuardarProyectoRequestSchema: GenMessage<GuardarProyectoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 16);

/**
 * Items del presupuesto del proyecto. Reemplaza todos los anteriores.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarItemsProyectoRequest
 */
export type GuardarItemsProyectoRequest = Message<"sextante.plataforma.proyectos.v1.GuardarItemsProyectoRequest"> & {
  /**
   * @generated from field: string proyecto_id = 1;
   */
  proyectoId: string;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.ItemProyectoRequest items = 2;
   */
  items: ItemProyectoRequest[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarItemsProyectoRequest.
 * Use `create(GuardarItemsProyectoRequestSchema)` to create a new message.
 */
export const GuardarItemsProyectoRequestSchema: GenMessage<GuardarItemsProyectoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 17);

/**
 * Item del presupuesto a guardar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ItemProyectoRequest
 */
export type ItemProyectoRequest = Message<"sextante.plataforma.proyectos.v1.ItemProyectoRequest"> & {
  /**
   * Id del item del catalogo.
   *
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * Cantidad por hectarea.
   *
   * @generated from field: double cantidad = 2;
   */
  cantidad: number;

  /**
   * Ausente = un item nuevo toma el precio vigente del catalogo con el snapshot del proyecto, y uno que ya
   * estaba conserva el suyo.
   *
   * @generated from field: optional int64 precio_unitario = 3;
   */
  precioUnitario?: bigint | undefined;

  /**
   * @generated from field: bool activo = 4;
   */
  activo: boolean;

  /**
   * Avance de la labor: pendiente, en_ejecucion o completado. Ausente = conserva el que tenia.
   *
   * @generated from field: optional string avance_estado = 5;
   */
  avanceEstado?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ItemProyectoRequest.
 * Use `create(ItemProyectoRequestSchema)` to create a new message.
 */
export const ItemProyectoRequestSchema: GenMessage<ItemProyectoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 18);

/**
 * Estado nuevo de un proyecto: borrador, en_revision, aprobado, activo, cerrado o suspendido.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CambiarEstadoProyectoRequest
 */
export type CambiarEstadoProyectoRequest = Message<"sextante.plataforma.proyectos.v1.CambiarEstadoProyectoRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string estado = 2;
   */
  estado: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CambiarEstadoProyectoRequest.
 * Use `create(CambiarEstadoProyectoRequestSchema)` to create a new message.
 */
export const CambiarEstadoProyectoRequestSchema: GenMessage<CambiarEstadoProyectoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 19);

/**
 * Gasto a crear o editar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarGastoRequest
 */
export type GuardarGastoRequest = Message<"sextante.plataforma.proyectos.v1.GuardarGastoRequest"> & {
  /**
   * Presente = editar.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string proyecto_id = 2;
   */
  proyectoId: string;

  /**
   * Id del item del catalogo.
   *
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * Unix ms
   *
   * @generated from field: int64 fecha = 4;
   */
  fecha: bigint;

  /**
   * @generated from field: double cantidad_real = 5;
   */
  cantidadReal: number;

  /**
   * @generated from field: int64 precio_unitario_real = 6;
   */
  precioUnitarioReal: bigint;

  /**
   * @generated from field: optional string proveedor = 7;
   */
  proveedor?: string | undefined;

  /**
   * @generated from field: optional string observaciones = 8;
   */
  observaciones?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarGastoRequest.
 * Use `create(GuardarGastoRequestSchema)` to create a new message.
 */
export const GuardarGastoRequestSchema: GenMessage<GuardarGastoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 20);

/**
 * Gasto sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GastoIdRequest
 */
export type GastoIdRequest = Message<"sextante.plataforma.proyectos.v1.GastoIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GastoIdRequest.
 * Use `create(GastoIdRequestSchema)` to create a new message.
 */
export const GastoIdRequestSchema: GenMessage<GastoIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 21);

/**
 * Cantidad que se pide de un item del proyecto (solo Nitrofert).
 *
 * @generated from message sextante.plataforma.proyectos.v1.SolicitarCantidadRequest
 */
export type SolicitarCantidadRequest = Message<"sextante.plataforma.proyectos.v1.SolicitarCantidadRequest"> & {
  /**
   * @generated from field: string proyecto_id = 1;
   */
  proyectoId: string;

  /**
   * Item del catalogo (como en GuardarGasto), no el id del item dentro del proyecto.
   *
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * Mayor que cero, en la unidad del item.
   *
   * @generated from field: double cantidad = 3;
   */
  cantidad: number;

  /**
   * @generated from field: optional string observaciones = 4;
   */
  observaciones?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.SolicitarCantidadRequest.
 * Use `create(SolicitarCantidadRequestSchema)` to create a new message.
 */
export const SolicitarCantidadRequestSchema: GenMessage<SolicitarCantidadRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 22);

/**
 * Avance real de una labor del proyecto.
 *
 * @generated from message sextante.plataforma.proyectos.v1.MarcarAvanceRequest
 */
export type MarcarAvanceRequest = Message<"sextante.plataforma.proyectos.v1.MarcarAvanceRequest"> & {
  /**
   * @generated from field: string proyecto_id = 1;
   */
  proyectoId: string;

  /**
   * Item del catalogo (como en GuardarGasto), no el id del item dentro del proyecto.
   *
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * pendiente, en_ejecucion o completado.
   *
   * @generated from field: string avance_estado = 3;
   */
  avanceEstado: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.MarcarAvanceRequest.
 * Use `create(MarcarAvanceRequestSchema)` to create a new message.
 */
export const MarcarAvanceRequestSchema: GenMessage<MarcarAvanceRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 23);

/**
 * Cambios de UN item del presupuesto. Lo que no viene no se toca.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ActualizarItemProyectoRequest
 */
export type ActualizarItemProyectoRequest = Message<"sextante.plataforma.proyectos.v1.ActualizarItemProyectoRequest"> & {
  /**
   * @generated from field: string proyecto_id = 1;
   */
  proyectoId: string;

  /**
   * Item del catalogo (como en GuardarGasto), no el id del item dentro del proyecto.
   *
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * Cantidad por hectarea.
   *
   * @generated from field: optional double cantidad = 3;
   */
  cantidad?: number | undefined;

  /**
   * @generated from field: optional bool activo = 4;
   */
  activo?: boolean | undefined;

  /**
   * pendiente, en_ejecucion o completado.
   *
   * @generated from field: optional string avance_estado = 5;
   */
  avanceEstado?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ActualizarItemProyectoRequest.
 * Use `create(ActualizarItemProyectoRequestSchema)` to create a new message.
 */
export const ActualizarItemProyectoRequestSchema: GenMessage<ActualizarItemProyectoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 24);

/**
 * Cultivo de proyectos.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CultivoProyectoItem
 */
export type CultivoProyectoItem = Message<"sextante.plataforma.proyectos.v1.CultivoProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * Meses desde la siembra hasta la cosecha.
   *
   * @generated from field: int32 meses_a_cosecha = 3;
   */
  mesesACosecha: number;

  /**
   * Slug derivado del nombre ("Limón Tahití" → "limon-tahiti"); la pantalla de cultivos lo muestra.
   *
   * @generated from field: string slug = 4;
   */
  slug: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CultivoProyectoItem.
 * Use `create(CultivoProyectoItemSchema)` to create a new message.
 */
export const CultivoProyectoItemSchema: GenMessage<CultivoProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 25);

/**
 * Cultivos de proyectos no eliminados.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListCultivosProyectoResponse
 */
export type ListCultivosProyectoResponse = Message<"sextante.plataforma.proyectos.v1.ListCultivosProyectoResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.CultivoProyectoItem items = 1;
   */
  items: CultivoProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListCultivosProyectoResponse.
 * Use `create(ListCultivosProyectoResponseSchema)` to create a new message.
 */
export const ListCultivosProyectoResponseSchema: GenMessage<ListCultivosProyectoResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 26);

/**
 * Cultivo del que se pide el catalogo.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CatalogoByCultivoRequest
 */
export type CatalogoByCultivoRequest = Message<"sextante.plataforma.proyectos.v1.CatalogoByCultivoRequest"> & {
  /**
   * @generated from field: string cultivo_id = 1;
   */
  cultivoId: string;

  /**
   * Beneficiario del que ademas se quieren sus items propios. Ausente = solo el catalogo maestro, que es
   * lo que pide la pantalla de Catalogo; presente = maestro mas los propios de ese beneficiario, que es
   * lo que pide el wizard en el paso del paquete tecnologico.
   *
   * @generated from field: optional string cliente_id = 2;
   */
  clienteId?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CatalogoByCultivoRequest.
 * Use `create(CatalogoByCultivoRequestSchema)` to create a new message.
 */
export const CatalogoByCultivoRequestSchema: GenMessage<CatalogoByCultivoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 27);

/**
 * Item del catalogo de un cultivo, con su precio.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CatalogoProyectoItem
 */
export type CatalogoProyectoItem = Message<"sextante.plataforma.proyectos.v1.CatalogoProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string cultivo_id = 2;
   */
  cultivoId: string;

  /**
   * @generated from field: string cultivo_nombre = 3;
   */
  cultivoNombre: string;

  /**
   * Seccion del catalogo, para agrupar.
   *
   * @generated from field: string sec = 4;
   */
  sec: string;

  /**
   * Subseccion del catalogo, para agrupar.
   *
   * @generated from field: string sub = 5;
   */
  sub: string;

  /**
   * CAPEX u OPEX.
   *
   * @generated from field: string tipo = 6;
   */
  tipo: string;

  /**
   * @generated from field: string nombre = 7;
   */
  nombre: string;

  /**
   * @generated from field: string categoria = 8;
   */
  categoria: string;

  /**
   * @generated from field: string unidad = 9;
   */
  unidad: string;

  /**
   * @generated from field: string cant_unidad = 10;
   */
  cantUnidad: string;

  /**
   * smmlv | ipc | fijo | volatil
   *
   * @generated from field: string tipo_p = 11;
   */
  tipoP: string;

  /**
   * Precio base cargado a mano, en pesos.
   *
   * @generated from field: optional int64 precio_referencial = 12;
   */
  precioReferencial?: bigint | undefined;

  /**
   * Con el factor jornal del snapshot activo y la tasa de IPC de su categoria en la cosecha vigente; ausente
   * si no hay precio.
   *
   * @generated from field: optional int64 precio_vigente = 13;
   */
  precioVigente?: bigint | undefined;

  /**
   * @generated from field: bool activo = 14;
   */
  activo: boolean;

  /**
   * Item marcado NITRO: se resalta en el catalogo y el presupuesto.
   *
   * @generated from field: bool nitro = 15;
   */
  nitro: boolean;

  /**
   * Cantidad por hectarea que se propone al agregar el item a un proyecto nuevo.
   *
   * @generated from field: double cantidad_por_ha = 16;
   */
  cantidadPorHa: number;

  /**
   * Repeticiones dentro de la fase, por ejemplo 3 aplicaciones. 1 = sin repeticiones.
   *
   * @generated from field: double freq = 17;
   */
  freq: number;

  /**
   * Texto que acompana a freq, como apps, meses o veces.
   *
   * @generated from field: optional string freq_unidad = 18;
   */
  freqUnidad?: string | undefined;

  /**
   * Como llega el item al crear un proyecto: obligatorio, incluido u opcional.
   *
   * @generated from field: string incl = 19;
   */
  incl: string;

  /**
   * Fase del item; ausente en items viejos, sin fase.
   *
   * @generated from field: optional string fase_id = 20;
   */
  faseId?: string | undefined;

  /**
   * @generated from field: optional string fase_codigo = 21;
   */
  faseCodigo?: string | undefined;

  /**
   * true = item propio de beneficiarios, no del catalogo maestro del cultivo.
   *
   * @generated from field: bool es_propio = 22;
   */
  esPropio: boolean;

  /**
   * Quien creo el item, con el nombre de ese momento. Ausente en todo el catalogo maestro.
   *
   * @generated from field: optional string creado_por_nombre = 23;
   */
  creadoPorNombre?: string | undefined;

  /**
   * Cuantos beneficiarios son duenos del item. 0 en el catalogo maestro. Varios duenos es la senal de
   * que el item ya se gano un puesto en el catalogo maestro.
   *
   * @generated from field: int32 duenos = 24;
   */
  duenos: number;

  /**
   * Por que el beneficiario consultado necesita el item. Solo viene si se pidio con cliente_id.
   *
   * @generated from field: optional string motivo = 25;
   */
  motivo?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CatalogoProyectoItem.
 * Use `create(CatalogoProyectoItemSchema)` to create a new message.
 */
export const CatalogoProyectoItemSchema: GenMessage<CatalogoProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 28);

/**
 * Items del catalogo del cultivo.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListCatalogoProyectoResponse
 */
export type ListCatalogoProyectoResponse = Message<"sextante.plataforma.proyectos.v1.ListCatalogoProyectoResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.CatalogoProyectoItem items = 1;
   */
  items: CatalogoProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListCatalogoProyectoResponse.
 * Use `create(ListCatalogoProyectoResponseSchema)` to create a new message.
 */
export const ListCatalogoProyectoResponseSchema: GenMessage<ListCatalogoProyectoResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 29);

/**
 * Precio referencial nuevo de un item.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ActualizarPrecioCatalogoRequest
 */
export type ActualizarPrecioCatalogoRequest = Message<"sextante.plataforma.proyectos.v1.ActualizarPrecioCatalogoRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Ausente = sin precio.
   *
   * @generated from field: optional int64 precio_referencial = 2;
   */
  precioReferencial?: bigint | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ActualizarPrecioCatalogoRequest.
 * Use `create(ActualizarPrecioCatalogoRequestSchema)` to create a new message.
 */
export const ActualizarPrecioCatalogoRequestSchema: GenMessage<ActualizarPrecioCatalogoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 30);

/**
 * Item del catalogo sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CatalogoItemIdRequest
 */
export type CatalogoItemIdRequest = Message<"sextante.plataforma.proyectos.v1.CatalogoItemIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CatalogoItemIdRequest.
 * Use `create(CatalogoItemIdRequestSchema)` to create a new message.
 */
export const CatalogoItemIdRequestSchema: GenMessage<CatalogoItemIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 31);

/**
 * Item propio a crear para un beneficiario, o item propio existente a asignarle.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarItemPropioRequest
 */
export type GuardarItemPropioRequest = Message<"sextante.plataforma.proyectos.v1.GuardarItemPropioRequest"> & {
  /**
   * Beneficiario dueno del item.
   *
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;

  /**
   * Por que este beneficiario lo necesita. Obligatorio y corto: es lo unico que despues distingue un
   * item que de verdad falta en el catalogo de uno que alguien creo por no haber buscado bien.
   *
   * @generated from field: string motivo = 2;
   */
  motivo: string;

  /**
   * Presente = asignarle a este beneficiario un item propio que ya existe, sin crear otro igual (lo que
   * ofrece BuscarItemsPropiosParecidos). Los campos del item se ignoran. Si ya era dueno, no pasa nada.
   * Ausente = crear el item.
   *
   * @generated from field: optional string catalogo_item_id = 3;
   */
  catalogoItemId?: string | undefined;

  /**
   * Campos del item, solo al crear.
   *
   * @generated from field: string cultivo_id = 4;
   */
  cultivoId: string;

  /**
   * @generated from field: string fase_id = 5;
   */
  faseId: string;

  /**
   * Subseccion del catalogo, para agrupar.
   *
   * @generated from field: string sub = 6;
   */
  sub: string;

  /**
   * @generated from field: string nombre = 7;
   */
  nombre: string;

  /**
   * @generated from field: string categoria = 8;
   */
  categoria: string;

  /**
   * @generated from field: string unidad = 9;
   */
  unidad: string;

  /**
   * @generated from field: string cant_unidad = 10;
   */
  cantUnidad: string;

  /**
   * Mayor a 0.
   *
   * @generated from field: double cantidad_por_ha = 11;
   */
  cantidadPorHa: number;

  /**
   * smmlv | ipc | fijo | volatil
   *
   * @generated from field: string tipo_p = 12;
   */
  tipoP: string;

  /**
   * @generated from field: optional int64 precio_referencial = 13;
   */
  precioReferencial?: bigint | undefined;

  /**
   * Mayor a 0.
   *
   * @generated from field: double freq = 14;
   */
  freq: number;

  /**
   * @generated from field: optional string freq_unidad = 15;
   */
  freqUnidad?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarItemPropioRequest.
 * Use `create(GuardarItemPropioRequestSchema)` to create a new message.
 */
export const GuardarItemPropioRequestSchema: GenMessage<GuardarItemPropioRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 32);

/**
 * Busqueda de items propios parecidos antes de crear uno nuevo.
 *
 * @generated from message sextante.plataforma.proyectos.v1.BuscarItemsPropiosRequest
 */
export type BuscarItemsPropiosRequest = Message<"sextante.plataforma.proyectos.v1.BuscarItemsPropiosRequest"> & {
  /**
   * @generated from field: string cultivo_id = 1;
   */
  cultivoId: string;

  /**
   * Nombre que esta escribiendo el usuario. Se compara sin tildes, sin mayusculas y sin espacios de sobra.
   *
   * @generated from field: string nombre = 2;
   */
  nombre: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.BuscarItemsPropiosRequest.
 * Use `create(BuscarItemsPropiosRequestSchema)` to create a new message.
 */
export const BuscarItemsPropiosRequestSchema: GenMessage<BuscarItemsPropiosRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 33);

/**
 * Item propio que se le suelta a un beneficiario.
 *
 * @generated from message sextante.plataforma.proyectos.v1.QuitarItemPropioRequest
 */
export type QuitarItemPropioRequest = Message<"sextante.plataforma.proyectos.v1.QuitarItemPropioRequest"> & {
  /**
   * @generated from field: string catalogo_item_id = 1;
   */
  catalogoItemId: string;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.QuitarItemPropioRequest.
 * Use `create(QuitarItemPropioRequestSchema)` to create a new message.
 */
export const QuitarItemPropioRequestSchema: GenMessage<QuitarItemPropioRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 34);

/**
 * Parametros economicos de un anio para presupuestar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.SnapshotProyectoItem
 */
export type SnapshotProyectoItem = Message<"sextante.plataforma.proyectos.v1.SnapshotProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 anio = 2;
   */
  anio: number;

  /**
   * Salario minimo mensual del anio, en pesos.
   *
   * @generated from field: int64 smmlv = 3;
   */
  smmlv: bigint;

  /**
   * @generated from field: int64 subsidio_transporte = 4;
   */
  subsidioTransporte: bigint;

  /**
   * Valor del jornal diario, en pesos. Lo calcula el servidor: salario minimo mas subsidio de transporte, por
   * 1.2173 de prestaciones, dividido 30.
   *
   * @generated from field: int64 factor_jornal = 5;
   */
  factorJornal: bigint;

  /**
   * Inflacion proyectada del anio.
   *
   * @generated from field: double ipc = 6;
   */
  ipc: number;

  /**
   * Inflacion real publicada por el DANE, cuando se conoce.
   *
   * @generated from field: optional double ipc_real = 7;
   */
  ipcReal?: number | undefined;

  /**
   * @generated from field: optional string nota = 8;
   */
  nota?: string | undefined;

  /**
   * true si es el snapshot que usan los proyectos nuevos.
   *
   * @generated from field: bool activo = 9;
   */
  activo: boolean;

  /**
   * Proyectos que congelaron este snapshot.
   *
   * @generated from field: int32 total_proyectos = 10;
   */
  totalProyectos: number;

  /**
   * Unix ms
   *
   * @generated from field: int64 created_at = 11;
   */
  createdAt: bigint;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.SnapshotProyectoItem.
 * Use `create(SnapshotProyectoItemSchema)` to create a new message.
 */
export const SnapshotProyectoItemSchema: GenMessage<SnapshotProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 35);

/**
 * Snapshots.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListSnapshotsResponse
 */
export type ListSnapshotsResponse = Message<"sextante.plataforma.proyectos.v1.ListSnapshotsResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.SnapshotProyectoItem items = 1;
   */
  items: SnapshotProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListSnapshotsResponse.
 * Use `create(ListSnapshotsResponseSchema)` to create a new message.
 */
export const ListSnapshotsResponseSchema: GenMessage<ListSnapshotsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 36);

/**
 * Snapshot activo, si hay.
 *
 * @generated from message sextante.plataforma.proyectos.v1.SnapshotActivoResponse
 */
export type SnapshotActivoResponse = Message<"sextante.plataforma.proyectos.v1.SnapshotActivoResponse"> & {
  /**
   * @generated from field: optional sextante.plataforma.proyectos.v1.SnapshotProyectoItem snapshot = 1;
   */
  snapshot?: SnapshotProyectoItem | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.SnapshotActivoResponse.
 * Use `create(SnapshotActivoResponseSchema)` to create a new message.
 */
export const SnapshotActivoResponseSchema: GenMessage<SnapshotActivoResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 37);

/**
 * Snapshot sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.SnapshotIdRequest
 */
export type SnapshotIdRequest = Message<"sextante.plataforma.proyectos.v1.SnapshotIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.SnapshotIdRequest.
 * Use `create(SnapshotIdRequestSchema)` to create a new message.
 */
export const SnapshotIdRequestSchema: GenMessage<SnapshotIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 38);

/**
 * Snapshot a crear o editar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarSnapshotRequest
 */
export type GuardarSnapshotRequest = Message<"sextante.plataforma.proyectos.v1.GuardarSnapshotRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: int32 anio = 2;
   */
  anio: number;

  /**
   * @generated from field: int64 smmlv = 3;
   */
  smmlv: bigint;

  /**
   * @generated from field: int64 subsidio_transporte = 4;
   */
  subsidioTransporte: bigint;

  /**
   * @generated from field: double ipc = 5;
   */
  ipc: number;

  /**
   * @generated from field: optional string nota = 6;
   */
  nota?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarSnapshotRequest.
 * Use `create(GuardarSnapshotRequestSchema)` to create a new message.
 */
export const GuardarSnapshotRequestSchema: GenMessage<GuardarSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 39);

/**
 * Inflacion real de un snapshot.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ActualizarIpcRealRequest
 */
export type ActualizarIpcRealRequest = Message<"sextante.plataforma.proyectos.v1.ActualizarIpcRealRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: double ipc_real = 2;
   */
  ipcReal: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ActualizarIpcRealRequest.
 * Use `create(ActualizarIpcRealRequestSchema)` to create a new message.
 */
export const ActualizarIpcRealRequestSchema: GenMessage<ActualizarIpcRealRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 40);

/**
 * Tecnico de campo de proyectos.
 *
 * @generated from message sextante.plataforma.proyectos.v1.TecnicoProyectoItem
 */
export type TecnicoProyectoItem = Message<"sextante.plataforma.proyectos.v1.TecnicoProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: optional string telefono = 4;
   */
  telefono?: string | undefined;

  /**
   * Zona donde trabaja el tecnico.
   *
   * @generated from field: string zona = 5;
   */
  zona: string;

  /**
   * @generated from field: bool is_activo = 6;
   */
  isActivo: boolean;

  /**
   * Presente = tiene cuenta de Plataforma (invitacion enviada).
   *
   * @generated from field: optional string usuario_plataforma_id = 7;
   */
  usuarioPlataformaId?: string | undefined;

  /**
   * Proyectos no cerrados.
   *
   * @generated from field: int32 total_proyectos = 8;
   */
  totalProyectos: number;

  /**
   * @generated from field: double total_ha = 9;
   */
  totalHa: number;

  /**
   * Unix ms
   *
   * @generated from field: int64 created_at = 10;
   */
  createdAt: bigint;

  /**
   * Solo en la respuesta de GuardarTecnico: la ficha se enlazo a un usuario de Plataforma que ya existia con ese
   * correo, en vez de crear otro (Nitrofert). En los listados siempre false.
   *
   * @generated from field: bool enlazado_a_usuario_existente = 11;
   */
  enlazadoAUsuarioExistente: boolean;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.TecnicoProyectoItem.
 * Use `create(TecnicoProyectoItemSchema)` to create a new message.
 */
export const TecnicoProyectoItemSchema: GenMessage<TecnicoProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 41);

/**
 * Tecnicos.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListTecnicosResponse
 */
export type ListTecnicosResponse = Message<"sextante.plataforma.proyectos.v1.ListTecnicosResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.TecnicoProyectoItem items = 1;
   */
  items: TecnicoProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListTecnicosResponse.
 * Use `create(ListTecnicosResponseSchema)` to create a new message.
 */
export const ListTecnicosResponseSchema: GenMessage<ListTecnicosResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 42);

/**
 * Totales de tecnicos para los KPI.
 *
 * @generated from message sextante.plataforma.proyectos.v1.TecnicosStatsResponse
 */
export type TecnicosStatsResponse = Message<"sextante.plataforma.proyectos.v1.TecnicosStatsResponse"> & {
  /**
   * @generated from field: int32 total_tecnicos = 1;
   */
  totalTecnicos: number;

  /**
   * @generated from field: int32 activos = 2;
   */
  activos: number;

  /**
   * @generated from field: int32 total_proyectos = 3;
   */
  totalProyectos: number;

  /**
   * @generated from field: double promedio_por_tecnico = 4;
   */
  promedioPorTecnico: number;

  /**
   * @generated from field: double total_ha = 5;
   */
  totalHa: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.TecnicosStatsResponse.
 * Use `create(TecnicosStatsResponseSchema)` to create a new message.
 */
export const TecnicosStatsResponseSchema: GenMessage<TecnicosStatsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 43);

/**
 * Tecnico a crear o editar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarTecnicoRequest
 */
export type GuardarTecnicoRequest = Message<"sextante.plataforma.proyectos.v1.GuardarTecnicoRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: optional string telefono = 4;
   */
  telefono?: string | undefined;

  /**
   * @generated from field: string zona = 5;
   */
  zona: string;

  /**
   * @generated from field: bool is_activo = 6;
   */
  isActivo: boolean;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarTecnicoRequest.
 * Use `create(GuardarTecnicoRequestSchema)` to create a new message.
 */
export const GuardarTecnicoRequestSchema: GenMessage<GuardarTecnicoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 44);

/**
 * Tecnico sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.TecnicoIdRequest
 */
export type TecnicoIdRequest = Message<"sextante.plataforma.proyectos.v1.TecnicoIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.TecnicoIdRequest.
 * Use `create(TecnicoIdRequestSchema)` to create a new message.
 */
export const TecnicoIdRequestSchema: GenMessage<TecnicoIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 45);

/**
 * Item del catalogo a crear o editar. El tipo y la seccion salen de la fase.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarCatalogoItemRequest
 */
export type GuardarCatalogoItemRequest = Message<"sextante.plataforma.proyectos.v1.GuardarCatalogoItemRequest"> & {
  /**
   * Presente = editar.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string cultivo_id = 2;
   */
  cultivoId: string;

  /**
   * @generated from field: string fase_id = 3;
   */
  faseId: string;

  /**
   * Subseccion del catalogo, para agrupar.
   *
   * @generated from field: string sub = 4;
   */
  sub: string;

  /**
   * @generated from field: string nombre = 5;
   */
  nombre: string;

  /**
   * @generated from field: string categoria = 6;
   */
  categoria: string;

  /**
   * @generated from field: string unidad = 7;
   */
  unidad: string;

  /**
   * @generated from field: string cant_unidad = 8;
   */
  cantUnidad: string;

  /**
   * Mayor a 0.
   *
   * @generated from field: double cantidad_por_ha = 9;
   */
  cantidadPorHa: number;

  /**
   * smmlv | ipc | fijo | volatil
   *
   * @generated from field: string tipo_p = 10;
   */
  tipoP: string;

  /**
   * @generated from field: optional int64 precio_referencial = 11;
   */
  precioReferencial?: bigint | undefined;

  /**
   * Mayor a 0.
   *
   * @generated from field: double freq = 12;
   */
  freq: number;

  /**
   * @generated from field: optional string freq_unidad = 13;
   */
  freqUnidad?: string | undefined;

  /**
   * obligatorio | incluido | opcional
   *
   * @generated from field: string incl = 14;
   */
  incl: string;

  /**
   * @generated from field: bool nitro = 15;
   */
  nitro: boolean;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarCatalogoItemRequest.
 * Use `create(GuardarCatalogoItemRequestSchema)` to create a new message.
 */
export const GuardarCatalogoItemRequestSchema: GenMessage<GuardarCatalogoItemRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 46);

/**
 * Cultivo de proyectos a crear o editar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarCultivoProyectoRequest
 */
export type GuardarCultivoProyectoRequest = Message<"sextante.plataforma.proyectos.v1.GuardarCultivoProyectoRequest"> & {
  /**
   * Presente = editar.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: int32 meses_a_cosecha = 3;
   */
  mesesACosecha: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarCultivoProyectoRequest.
 * Use `create(GuardarCultivoProyectoRequestSchema)` to create a new message.
 */
export const GuardarCultivoProyectoRequestSchema: GenMessage<GuardarCultivoProyectoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 47);

/**
 * Cultivo sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CultivoProyectoIdRequest
 */
export type CultivoProyectoIdRequest = Message<"sextante.plataforma.proyectos.v1.CultivoProyectoIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CultivoProyectoIdRequest.
 * Use `create(CultivoProyectoIdRequestSchema)` to create a new message.
 */
export const CultivoProyectoIdRequestSchema: GenMessage<CultivoProyectoIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 48);

/**
 * Fase del catalogo, como F0 Establecimiento.
 *
 * @generated from message sextante.plataforma.proyectos.v1.FaseProyectoItem
 */
export type FaseProyectoItem = Message<"sextante.plataforma.proyectos.v1.FaseProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * F0, F1, F2...
   *
   * @generated from field: string codigo = 2;
   */
  codigo: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * CAPEX u OPEX.
   *
   * @generated from field: string tipo = 4;
   */
  tipo: string;

  /**
   * @generated from field: int32 orden = 5;
   */
  orden: number;

  /**
   * Mes de inicio y de fin, relativos al inicio del proyecto.
   *
   * @generated from field: int32 mes_inicio = 6;
   */
  mesInicio: number;

  /**
   * @generated from field: int32 mes_fin = 7;
   */
  mesFin: number;

  /**
   * @generated from field: bool activo = 8;
   */
  activo: boolean;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.FaseProyectoItem.
 * Use `create(FaseProyectoItemSchema)` to create a new message.
 */
export const FaseProyectoItemSchema: GenMessage<FaseProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 49);

/**
 * Fases, por orden.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListFasesResponse
 */
export type ListFasesResponse = Message<"sextante.plataforma.proyectos.v1.ListFasesResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.FaseProyectoItem items = 1;
   */
  items: FaseProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListFasesResponse.
 * Use `create(ListFasesResponseSchema)` to create a new message.
 */
export const ListFasesResponseSchema: GenMessage<ListFasesResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 50);

/**
 * Cosecha: el IPC base del anio y sus ajustes por categoria de item.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CosechaProyectoItem
 */
export type CosechaProyectoItem = Message<"sextante.plataforma.proyectos.v1.CosechaProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: int32 anio = 3;
   */
  anio: number;

  /**
   * Decimal: 0.05 = 5%.
   *
   * @generated from field: double tasa_base_ipc = 4;
   */
  tasaBaseIpc: number;

  /**
   * true si ya no se pueden cambiar sus tasas.
   *
   * @generated from field: bool frozen = 5;
   */
  frozen: boolean;

  /**
   * true si es la cosecha que fija el precio del catalogo ahora. Hay una sola.
   *
   * @generated from field: bool vigente = 6;
   */
  vigente: boolean;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_inicio_vigencia = 7;
   */
  fechaInicioVigencia?: bigint | undefined;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_fin_vigencia = 8;
   */
  fechaFinVigencia?: bigint | undefined;

  /**
   * activa | cerrada
   *
   * @generated from field: string estado = 9;
   */
  estado: string;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.CosechaCategoriaTasaItem tasas_por_categoria = 10;
   */
  tasasPorCategoria: CosechaCategoriaTasaItem[];

  /**
   * @generated from field: int32 total_macro_proyectos = 11;
   */
  totalMacroProyectos: number;

  /**
   * Proyectos de los macro-proyectos de esta cosecha.
   *
   * @generated from field: int32 total_proyectos = 12;
   */
  totalProyectos: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CosechaProyectoItem.
 * Use `create(CosechaProyectoItemSchema)` to create a new message.
 */
export const CosechaProyectoItemSchema: GenMessage<CosechaProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 51);

/**
 * Tasa de IPC de una categoria de item en una cosecha.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CosechaCategoriaTasaItem
 */
export type CosechaCategoriaTasaItem = Message<"sextante.plataforma.proyectos.v1.CosechaCategoriaTasaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string categoria = 2;
   */
  categoria: string;

  /**
   * Decimal: 0.05 = 5%.
   *
   * @generated from field: double tasa = 3;
   */
  tasa: number;

  /**
   * true si difiere de la tasa base de la cosecha.
   *
   * @generated from field: bool override = 4;
   */
  override: boolean;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CosechaCategoriaTasaItem.
 * Use `create(CosechaCategoriaTasaItemSchema)` to create a new message.
 */
export const CosechaCategoriaTasaItemSchema: GenMessage<CosechaCategoriaTasaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 52);

/**
 * Cosechas, por nombre.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListCosechasResponse
 */
export type ListCosechasResponse = Message<"sextante.plataforma.proyectos.v1.ListCosechasResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.CosechaProyectoItem items = 1;
   */
  items: CosechaProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListCosechasResponse.
 * Use `create(ListCosechasResponseSchema)` to create a new message.
 */
export const ListCosechasResponseSchema: GenMessage<ListCosechasResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 53);

/**
 * Cosecha a crear o editar. Reemplaza el set completo de tasas por categoria.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarCosechaRequest
 */
export type GuardarCosechaRequest = Message<"sextante.plataforma.proyectos.v1.GuardarCosechaRequest"> & {
  /**
   * Presente = editar.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: int32 anio = 3;
   */
  anio: number;

  /**
   * Decimal: 0.05 = 5%.
   *
   * @generated from field: double tasa_base_ipc = 4;
   */
  tasaBaseIpc: number;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_inicio_vigencia = 5;
   */
  fechaInicioVigencia?: bigint | undefined;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_fin_vigencia = 6;
   */
  fechaFinVigencia?: bigint | undefined;

  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.CosechaCategoriaTasaInput tasas_por_categoria = 7;
   */
  tasasPorCategoria: CosechaCategoriaTasaInput[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarCosechaRequest.
 * Use `create(GuardarCosechaRequestSchema)` to create a new message.
 */
export const GuardarCosechaRequestSchema: GenMessage<GuardarCosechaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 54);

/**
 * Tasa de una categoria a guardar en la cosecha.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CosechaCategoriaTasaInput
 */
export type CosechaCategoriaTasaInput = Message<"sextante.plataforma.proyectos.v1.CosechaCategoriaTasaInput"> & {
  /**
   * @generated from field: string categoria = 1;
   */
  categoria: string;

  /**
   * Decimal: 0.05 = 5%.
   *
   * @generated from field: double tasa = 2;
   */
  tasa: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CosechaCategoriaTasaInput.
 * Use `create(CosechaCategoriaTasaInputSchema)` to create a new message.
 */
export const CosechaCategoriaTasaInputSchema: GenMessage<CosechaCategoriaTasaInput> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 55);

/**
 * Cosecha sobre la que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.CosechaIdRequest
 */
export type CosechaIdRequest = Message<"sextante.plataforma.proyectos.v1.CosechaIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.CosechaIdRequest.
 * Use `create(CosechaIdRequestSchema)` to create a new message.
 */
export const CosechaIdRequestSchema: GenMessage<CosechaIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 56);

/**
 * Macro-proyecto: agrupa proyectos de una cosecha y una region, con sus totales.
 *
 * @generated from message sextante.plataforma.proyectos.v1.MacroProyectoItem
 */
export type MacroProyectoItem = Message<"sextante.plataforma.proyectos.v1.MacroProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string cosecha_id = 3;
   */
  cosechaId: string;

  /**
   * @generated from field: string cosecha_nombre = 4;
   */
  cosechaNombre: string;

  /**
   * @generated from field: double cosecha_tasa_base_ipc = 5;
   */
  cosechaTasaBaseIpc: number;

  /**
   * @generated from field: bool cosecha_frozen = 6;
   */
  cosechaFrozen: boolean;

  /**
   * @generated from field: string region = 7;
   */
  region: string;

  /**
   * en_configuracion | activo | cerrado
   *
   * @generated from field: string estado = 8;
   */
  estado: string;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_activacion = 9;
   */
  fechaActivacion?: bigint | undefined;

  /**
   * @generated from field: optional string descripcion = 10;
   */
  descripcion?: string | undefined;

  /**
   * @generated from field: repeated string cultivo_ids = 11;
   */
  cultivoIds: string[];

  /**
   * @generated from field: repeated string cultivo_nombres = 12;
   */
  cultivoNombres: string[];

  /**
   * @generated from field: int32 total_proyectos = 13;
   */
  totalProyectos: number;

  /**
   * @generated from field: double total_ha = 14;
   */
  totalHa: number;

  /**
   * Presupuesto de los items activos con precio de sus proyectos, en pesos.
   *
   * @generated from field: int64 monto_total = 15;
   */
  montoTotal: bigint;

  /**
   * Gastos reales de sus proyectos, en pesos.
   *
   * @generated from field: int64 ejecutado_total = 16;
   */
  ejecutadoTotal: bigint;

  /**
   * @generated from field: int32 proyectos_activos = 17;
   */
  proyectosActivos: number;

  /**
   * @generated from field: int32 proyectos_en_revision = 18;
   */
  proyectosEnRevision: number;

  /**
   * @generated from field: int32 proyectos_aprobados = 19;
   */
  proyectosAprobados: number;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.MacroProyectoItem.
 * Use `create(MacroProyectoItemSchema)` to create a new message.
 */
export const MacroProyectoItemSchema: GenMessage<MacroProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 57);

/**
 * Macro-proyectos, por nombre.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListMacroProyectosResponse
 */
export type ListMacroProyectosResponse = Message<"sextante.plataforma.proyectos.v1.ListMacroProyectosResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.MacroProyectoItem items = 1;
   */
  items: MacroProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListMacroProyectosResponse.
 * Use `create(ListMacroProyectosResponseSchema)` to create a new message.
 */
export const ListMacroProyectosResponseSchema: GenMessage<ListMacroProyectosResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 58);

/**
 * Macro-proyecto a crear o editar. Reemplaza el set completo de cultivos.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarMacroProyectoRequest
 */
export type GuardarMacroProyectoRequest = Message<"sextante.plataforma.proyectos.v1.GuardarMacroProyectoRequest"> & {
  /**
   * Presente = editar.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string cosecha_id = 3;
   */
  cosechaId: string;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * @generated from field: optional string descripcion = 5;
   */
  descripcion?: string | undefined;

  /**
   * @generated from field: repeated string cultivo_ids = 6;
   */
  cultivoIds: string[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarMacroProyectoRequest.
 * Use `create(GuardarMacroProyectoRequestSchema)` to create a new message.
 */
export const GuardarMacroProyectoRequestSchema: GenMessage<GuardarMacroProyectoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 59);

/**
 * Macro-proyecto sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.MacroProyectoIdRequest
 */
export type MacroProyectoIdRequest = Message<"sextante.plataforma.proyectos.v1.MacroProyectoIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.MacroProyectoIdRequest.
 * Use `create(MacroProyectoIdRequestSchema)` to create a new message.
 */
export const MacroProyectoIdRequestSchema: GenMessage<MacroProyectoIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 60);

/**
 * Nucleo: grupo de productores de una region, con su tecnico y sus topes de referencia.
 *
 * @generated from message sextante.plataforma.proyectos.v1.NucleoProyectoItem
 */
export type NucleoProyectoItem = Message<"sextante.plataforma.proyectos.v1.NucleoProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: optional string cultivo_id = 4;
   */
  cultivoId?: string | undefined;

  /**
   * @generated from field: optional string cultivo_nombre = 5;
   */
  cultivoNombre?: string | undefined;

  /**
   * @generated from field: optional string tecnico_id = 6;
   */
  tecnicoId?: string | undefined;

  /**
   * @generated from field: optional string tecnico_nombre = 7;
   */
  tecnicoNombre?: string | undefined;

  /**
   * @generated from field: optional string macro_proyecto_id = 8;
   */
  macroProyectoId?: string | undefined;

  /**
   * @generated from field: optional string macro_proyecto_nombre = 9;
   */
  macroProyectoNombre?: string | undefined;

  /**
   * Hectareas maximas de asociacion: la web avisa si un proyecto las supera.
   *
   * @generated from field: optional double ha_max_asociacion = 10;
   */
  haMaxAsociacion?: number | undefined;

  /**
   * Monto maximo de referencia en pesos: la web lo sugiere como limite financiero del proyecto.
   *
   * @generated from field: optional int64 monto_max_referencial = 11;
   */
  montoMaxReferencial?: bigint | undefined;

  /**
   * @generated from field: int32 total_proyectos = 12;
   */
  totalProyectos: number;

  /**
   * Unix ms
   *
   * @generated from field: int64 created_at = 13;
   */
  createdAt: bigint;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.NucleoProyectoItem.
 * Use `create(NucleoProyectoItemSchema)` to create a new message.
 */
export const NucleoProyectoItemSchema: GenMessage<NucleoProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 61);

/**
 * Nucleos, por nombre.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListNucleosResponse
 */
export type ListNucleosResponse = Message<"sextante.plataforma.proyectos.v1.ListNucleosResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.NucleoProyectoItem items = 1;
   */
  items: NucleoProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListNucleosResponse.
 * Use `create(ListNucleosResponseSchema)` to create a new message.
 */
export const ListNucleosResponseSchema: GenMessage<ListNucleosResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 62);

/**
 * Nucleo a crear o editar.
 *
 * @generated from message sextante.plataforma.proyectos.v1.GuardarNucleoRequest
 */
export type GuardarNucleoRequest = Message<"sextante.plataforma.proyectos.v1.GuardarNucleoRequest"> & {
  /**
   * Presente = editar.
   *
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: optional string cultivo_id = 4;
   */
  cultivoId?: string | undefined;

  /**
   * @generated from field: optional string tecnico_id = 5;
   */
  tecnicoId?: string | undefined;

  /**
   * @generated from field: optional string macro_proyecto_id = 6;
   */
  macroProyectoId?: string | undefined;

  /**
   * @generated from field: optional double ha_max_asociacion = 7;
   */
  haMaxAsociacion?: number | undefined;

  /**
   * @generated from field: optional int64 monto_max_referencial = 8;
   */
  montoMaxReferencial?: bigint | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.GuardarNucleoRequest.
 * Use `create(GuardarNucleoRequestSchema)` to create a new message.
 */
export const GuardarNucleoRequestSchema: GenMessage<GuardarNucleoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 63);

/**
 * Nucleo sobre el que se actua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.NucleoIdRequest
 */
export type NucleoIdRequest = Message<"sextante.plataforma.proyectos.v1.NucleoIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.NucleoIdRequest.
 * Use `create(NucleoIdRequestSchema)` to create a new message.
 */
export const NucleoIdRequestSchema: GenMessage<NucleoIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 64);

/**
 * Entrada de la bitacora de un proyecto.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ActividadProyectoItem
 */
export type ActividadProyectoItem = Message<"sextante.plataforma.proyectos.v1.ActividadProyectoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string proyecto_id = 2;
   */
  proyectoId: string;

  /**
   * Usuario de Plataforma que la genero; ausente si fue el sistema.
   *
   * @generated from field: optional string usuario_nombre = 3;
   */
  usuarioNombre?: string | undefined;

  /**
   * creado | editado | estado | comentario
   *
   * @generated from field: string tipo = 4;
   */
  tipo: string;

  /**
   * @generated from field: string titulo = 5;
   */
  titulo: string;

  /**
   * @generated from field: optional string descripcion = 6;
   */
  descripcion?: string | undefined;

  /**
   * Unix ms
   *
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ActividadProyectoItem.
 * Use `create(ActividadProyectoItemSchema)` to create a new message.
 */
export const ActividadProyectoItemSchema: GenMessage<ActividadProyectoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 65);

/**
 * Bitacora del proyecto, de la entrada mas reciente a la mas antigua.
 *
 * @generated from message sextante.plataforma.proyectos.v1.ListActividadResponse
 */
export type ListActividadResponse = Message<"sextante.plataforma.proyectos.v1.ListActividadResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.proyectos.v1.ActividadProyectoItem items = 1;
   */
  items: ActividadProyectoItem[];
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.ListActividadResponse.
 * Use `create(ListActividadResponseSchema)` to create a new message.
 */
export const ListActividadResponseSchema: GenMessage<ListActividadResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 66);

/**
 * Comentario a agregar en la bitacora de un proyecto.
 *
 * @generated from message sextante.plataforma.proyectos.v1.AgregarComentarioRequest
 */
export type AgregarComentarioRequest = Message<"sextante.plataforma.proyectos.v1.AgregarComentarioRequest"> & {
  /**
   * @generated from field: string proyecto_id = 1;
   */
  proyectoId: string;

  /**
   * @generated from field: string titulo = 2;
   */
  titulo: string;

  /**
   * @generated from field: optional string descripcion = 3;
   */
  descripcion?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.proyectos.v1.AgregarComentarioRequest.
 * Use `create(AgregarComentarioRequestSchema)` to create a new message.
 */
export const AgregarComentarioRequestSchema: GenMessage<AgregarComentarioRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_proyectos, 67);

/**
 * Modulo Proyectos de la app Plataforma (menus Dashboard, Proyectos, Catalogo, Parametros, Macro-proyectos,
 * Nucleos, Cultivos y Tecnicos): presupuesto de cultivos por proyecto, gastos reales, bitacora, catalogo de
 * items con precios, cosechas con IPC por categoria, macro-proyectos, nucleos, parametros economicos
 * anuales (snapshots) y tecnicos de campo. Migracion a gRPC-Web con logica propia (ver CLAUDE.md); el
 * 2026-10-03 se porto aca lo que la rama feature/mapa-recorrido-por-lote habia agregado por REST. Montos en
 * pesos COP enteros; decimales (ha, cantidades, IPC) como double. Solo los campos que usa la web. Requiere
 * sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.proyectos.v1.ProyectosPlataformaService
 */
export const ProyectosPlataformaService: GenService<{
  /**
   * KPIs del dashboard de proyectos activos.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GetDashboardStats
   */
  getDashboardStats: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof DashboardProyectosStatsResponseSchema;
  },
  /**
   * ── Proyectos ──
   * Proyectos no eliminados.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListProyectos
   */
  listProyectos: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListProyectosResponseSchema;
  },
  /**
   * Proyectos del tecnico de la sesion (portal del tecnico). Vacio si la sesion no es de un tecnico.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListMisProyectosTecnico
   */
  listMisProyectosTecnico: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListProyectosResponseSchema;
  },
  /**
   * Proyecto + KPIs + items con sus gastos.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GetDetalle
   */
  getDetalle: {
    methodKind: "unary";
    input: typeof ProyectoIdRequestSchema;
    output: typeof ProyectoDetalleResponseSchema;
  },
  /**
   * Presupuesto proyectado hasta cosecha (OPEX con IPC compuesto) frente a lo ejecutado.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GetPresupuesto
   */
  getPresupuesto: {
    methodKind: "unary";
    input: typeof ProyectoIdRequestSchema;
    output: typeof PresupuestoProyectoResponseSchema;
  },
  /**
   * Alta o edicion. El alta congela el snapshot activo y las tasas de IPC de la cosecha vigente (error si no
   * hay snapshot activo) y deja la entrada "Proyecto creado" en la bitacora. Sin nucleo, hereda el del ultimo
   * proyecto del mismo cliente.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarProyecto
   */
  guardarProyecto: {
    methodKind: "unary";
    input: typeof GuardarProyectoRequestSchema;
    output: typeof ProyectoPlataformaItemSchema;
  },
  /**
   * Reemplazo completo de los items (los no enviados se eliminan). Un item que ya estaba conserva su precio y
   * su frecuencia congelados salvo que venga un precio propio; uno nuevo toma precio y frecuencia del
   * catalogo.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarItems
   */
  guardarItems: {
    methodKind: "unary";
    input: typeof GuardarItemsProyectoRequestSchema;
    output: typeof ProyectoPlataformaItemSchema;
  },
  /**
   * Un paso del flujo de estados: borrador, en_revision, aprobado, activo, cerrado o suspendido. Una
   * transicion no permitida es InvalidArgument. Deja la entrada en la bitacora.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.CambiarEstado
   */
  cambiarEstado: {
    methodKind: "unary";
    input: typeof CambiarEstadoProyectoRequestSchema;
    output: typeof ProyectoPlataformaItemSchema;
  },
  /**
   * Baja logica. Idempotente.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.EliminarProyecto
   */
  eliminarProyecto: {
    methodKind: "unary";
    input: typeof ProyectoIdRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * Bitacora del proyecto, de la entrada mas reciente a la mas antigua. Un tecnico, solo de sus proyectos.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListActividad
   */
  listActividad: {
    methodKind: "unary";
    input: typeof ProyectoIdRequestSchema;
    output: typeof ListActividadResponseSchema;
  },
  /**
   * Agrega un comentario manual a la bitacora, a nombre del usuario de la sesion. Un tecnico, solo en sus
   * proyectos.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.AgregarComentario
   */
  agregarComentario: {
    methodKind: "unary";
    input: typeof AgregarComentarioRequestSchema;
    output: typeof ActividadProyectoItemSchema;
  },
  /**
   * ── Gastos ──
   * Alta o edicion de un gasto real de un item del proyecto; el total lo calcula el servidor. Solo Sextante:
   * en Nitrofert los gastos los registra Nitrofert por NitrofertApi y esto responde FailedPrecondition.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarGasto
   */
  guardarGasto: {
    methodKind: "unary";
    input: typeof GuardarGastoRequestSchema;
    output: typeof GastoProyectoItemSchema;
  },
  /**
   * Baja logica de un gasto. Si no existe no hace nada. Solo Sextante, igual que GuardarGasto.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.EliminarGasto
   */
  eliminarGasto: {
    methodKind: "unary";
    input: typeof GastoIdRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * Solo Nitrofert: pide una cantidad de un item del proyecto. Nitrofert la atiende registrando gastos por
   * NitrofertApi (POST /api/solicitudes/{id}/gastos), en una o varias entregas. No se edita ni se anula. Un
   * tecnico, solo en sus proyectos. En Sextante responde FailedPrecondition.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.SolicitarCantidad
   */
  solicitarCantidad: {
    methodKind: "unary";
    input: typeof SolicitarCantidadRequestSchema;
    output: typeof SolicitudProyectoItemSchema;
  },
  /**
   * Marca el avance real de una labor (pendiente, en_ejecucion o completado) sin tocar el resto del item.
   * Es como lo marca el tecnico, solo en sus proyectos; el administrador tambien puede usarlo. Deja la entrada
   * en la bitacora si el avance cambio.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.MarcarAvance
   */
  marcarAvance: {
    methodKind: "unary";
    input: typeof MarcarAvanceRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * Edita UN item del presupuesto sin tocar los demas: cantidad, activo o avance (ausente = no tocar). Asi dos
   * personas que editan items distintos del mismo proyecto no se pisan, como pasaba con GuardarItems, que
   * reemplaza todos. El tecnico, solo en sus proyectos y solo el avance. Deja la entrada en la bitacora si algo
   * cambio; si nada cambio, no escribe nada.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ActualizarItem
   */
  actualizarItem: {
    methodKind: "unary";
    input: typeof ActualizarItemProyectoRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * ── Catalogo ──
   * Cultivos de proyecto no eliminados.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListCultivos
   */
  listCultivos: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListCultivosProyectoResponseSchema;
  },
  /**
   * Items del catalogo de un cultivo, con el precio vigente segun el snapshot activo.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListCatalogoByCultivo
   */
  listCatalogoByCultivo: {
    methodKind: "unary";
    input: typeof CatalogoByCultivoRequestSchema;
    output: typeof ListCatalogoProyectoResponseSchema;
  },
  /**
   * Cambia el precio referencial (ausente = sin precio).
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ActualizarPrecioCatalogo
   */
  actualizarPrecioCatalogo: {
    methodKind: "unary";
    input: typeof ActualizarPrecioCatalogoRequestSchema;
    output: typeof CatalogoProyectoItemSchema;
  },
  /**
   * Activa o desactiva un item del catalogo.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ToggleActivoCatalogo
   */
  toggleActivoCatalogo: {
    methodKind: "unary";
    input: typeof CatalogoItemIdRequestSchema;
    output: typeof CatalogoProyectoItemSchema;
  },
  /**
   * Alta o edicion de un item del catalogo maestro. El tipo (CAPEX u OPEX) y la seccion salen de la fase.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarCatalogoItem
   */
  guardarCatalogoItem: {
    methodKind: "unary";
    input: typeof GuardarCatalogoItemRequestSchema;
    output: typeof CatalogoProyectoItemSchema;
  },
  /**
   * ── Items propios de un beneficiario ──
   * 
   * Un item que un beneficiario necesita y que no esta en el catalogo maestro de su cultivo. Vive en la
   * misma tabla que el catalogo -por eso entra al presupuesto, congela precio y recibe gastos como
   * cualquier otro item-, pero marcado es_propio y con duenos. No lo ve nadie mas.
   * 
   * Crea el item para el beneficiario, o se lo asigna a otro beneficiario si ya existe (ver
   * catalogo_item_id). Reusar en vez de copiar es lo que mantiene esto revisable.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarItemPropio
   */
  guardarItemPropio: {
    methodKind: "unary";
    input: typeof GuardarItemPropioRequestSchema;
    output: typeof CatalogoProyectoItemSchema;
  },
  /**
   * Items propios del cultivo con nombre parecido, para ofrecer reusar uno antes de crear otro igual.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.BuscarItemsPropiosParecidos
   */
  buscarItemsPropiosParecidos: {
    methodKind: "unary";
    input: typeof BuscarItemsPropiosRequestSchema;
    output: typeof ListCatalogoProyectoResponseSchema;
  },
  /**
   * Suelta el item de un beneficiario. El item sigue existiendo para los demas duenos.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.QuitarItemPropio
   */
  quitarItemPropio: {
    methodKind: "unary";
    input: typeof QuitarItemPropioRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * Baja de un item del catalogo. Si algun proyecto lo usa, aunque sea inactivo, InvalidArgument: hay que
   * desactivarlo.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.EliminarCatalogoItem
   */
  eliminarCatalogoItem: {
    methodKind: "unary";
    input: typeof CatalogoItemIdRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * Alta o edicion de un cultivo de proyectos. El slug sale del nombre.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarCultivo
   */
  guardarCultivo: {
    methodKind: "unary";
    input: typeof GuardarCultivoProyectoRequestSchema;
    output: typeof CultivoProyectoItemSchema;
  },
  /**
   * Baja de un cultivo. Si tiene items de catalogo o proyectos, InvalidArgument.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.EliminarCultivo
   */
  eliminarCultivo: {
    methodKind: "unary";
    input: typeof CultivoProyectoIdRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * Fases del catalogo (F0, F1, F2...), por orden.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListFases
   */
  listFases: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListFasesResponseSchema;
  },
  /**
   * Cosechas no eliminadas con sus tasas de IPC por categoria, por nombre.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListCosechas
   */
  listCosechas: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListCosechasResponseSchema;
  },
  /**
   * Alta o edicion; reemplaza el set completo de tasas por categoria. Una cosecha congelada no se edita
   * (InvalidArgument).
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarCosecha
   */
  guardarCosecha: {
    methodKind: "unary";
    input: typeof GuardarCosechaRequestSchema;
    output: typeof CosechaProyectoItemSchema;
  },
  /**
   * Congela la cosecha: sus tasas ya no se pueden cambiar. Idempotente.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ActivarCosecha
   */
  activarCosecha: {
    methodKind: "unary";
    input: typeof CosechaIdRequestSchema;
    output: typeof CosechaProyectoItemSchema;
  },
  /**
   * Marca la cosecha como vigente, la que fija el precio del catalogo, y desmarca las demas.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.MarcarCosechaVigente
   */
  marcarCosechaVigente: {
    methodKind: "unary";
    input: typeof CosechaIdRequestSchema;
    output: typeof CosechaProyectoItemSchema;
  },
  /**
   * Macro-proyectos no eliminados con sus totales, por nombre.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListMacroProyectos
   */
  listMacroProyectos: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListMacroProyectosResponseSchema;
  },
  /**
   * Alta o edicion; reemplaza el set completo de cultivos. Un macro-proyecto cerrado no se edita
   * (InvalidArgument).
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarMacroProyecto
   */
  guardarMacroProyecto: {
    methodKind: "unary";
    input: typeof GuardarMacroProyectoRequestSchema;
    output: typeof MacroProyectoItemSchema;
  },
  /**
   * Activa un macro-proyecto en configuracion y congela su cosecha.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ActivarMacroProyecto
   */
  activarMacroProyecto: {
    methodKind: "unary";
    input: typeof MacroProyectoIdRequestSchema;
    output: typeof MacroProyectoItemSchema;
  },
  /**
   * Nucleos no eliminados, por nombre.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListNucleos
   */
  listNucleos: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListNucleosResponseSchema;
  },
  /**
   * Alta o edicion de un nucleo.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarNucleo
   */
  guardarNucleo: {
    methodKind: "unary";
    input: typeof GuardarNucleoRequestSchema;
    output: typeof NucleoProyectoItemSchema;
  },
  /**
   * Baja logica de un nucleo. Si no existe no hace nada.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.EliminarNucleo
   */
  eliminarNucleo: {
    methodKind: "unary";
    input: typeof NucleoIdRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
  /**
   * Snapshots no eliminados, del anio mas reciente al mas antiguo.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListSnapshots
   */
  listSnapshots: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListSnapshotsResponseSchema;
  },
  /**
   * El snapshot activo, ausente si no hay.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GetSnapshotActivo
   */
  getSnapshotActivo: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof SnapshotActivoResponseSchema;
  },
  /**
   * Alta o edicion; el factor jornal lo calcula el servidor.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarSnapshot
   */
  guardarSnapshot: {
    methodKind: "unary";
    input: typeof GuardarSnapshotRequestSchema;
    output: typeof SnapshotProyectoItemSchema;
  },
  /**
   * Desactiva los demas, activa este y captura los precios vigentes del catalogo.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ActivarSnapshot
   */
  activarSnapshot: {
    methodKind: "unary";
    input: typeof SnapshotIdRequestSchema;
    output: typeof SnapshotProyectoItemSchema;
  },
  /**
   * IPC real publicado por el DANE.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ActualizarIpcReal
   */
  actualizarIpcReal: {
    methodKind: "unary";
    input: typeof ActualizarIpcRealRequestSchema;
    output: typeof SnapshotProyectoItemSchema;
  },
  /**
   * Tecnicos no eliminados, con sus proyectos y hectareas no cerrados.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.ListTecnicos
   */
  listTecnicos: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof ListTecnicosResponseSchema;
  },
  /**
   * Totales para los KPI de tecnicos, sobre proyectos no cerrados.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GetTecnicosStats
   */
  getTecnicosStats: {
    methodKind: "unary";
    input: typeof ProyectosVacioRequestSchema;
    output: typeof TecnicosStatsResponseSchema;
  },
  /**
   * Alta (crea su usuario de Plataforma y le envia la invitacion) o edicion.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.GuardarTecnico
   */
  guardarTecnico: {
    methodKind: "unary";
    input: typeof GuardarTecnicoRequestSchema;
    output: typeof TecnicoProyectoItemSchema;
  },
  /**
   * Baja logica. Idempotente.
   *
   * @generated from rpc sextante.plataforma.proyectos.v1.ProyectosPlataformaService.EliminarTecnico
   */
  eliminarTecnico: {
    methodKind: "unary";
    input: typeof TecnicoIdRequestSchema;
    output: typeof ProyectosAccionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_proyectos, 0);

